import React from 'react';
import MarkDownJson from './MarkDownJson';

function Demon({ api }) {
  const now = parseInt((new Date()).valueOf() / 1000, 10);
  const dubboStyle = {
    api: `${api.uri}`,
    appKey: '',
    timestamp: now,
    sign: 'Your Sign',
    data: {

    }
  };
  const httpStyle = {
    api: `${api.uri}`,
    method: api.http_api ? api.http_api.method : 'POST',
    appKey: 'Your AppKey',
    timestamp: now,
    sign: 'Your Sign',
    data: {

    }
  }

  let style;

  if (api.type === 'http') {
    style = httpStyle;
  } else if (api.type === 'dubbo') {
    style = dubboStyle;
  } else {
    style = {};
  }

  return (
    <div>
      <MarkDownJson json={style} />
    </div>
  )
}

export default Demon;

